import { BlockUI } from "primereact/blockui";
import { Card } from "primereact/card";
import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Calendar } from 'primereact/calendar';
import { useEffect, useState } from 'react';
import { useGetStatusCountByConsultant } from "../../hooks/useGetDataQuery";

Chart.register(ArcElement, Tooltip, Legend);

const CarePlanCard = ({t}:any) => {
    const today = new Date();
    const [carePlanDate, setCarePlanCardDate] = useState<any>(today);
    const sixMonthAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);

    const {
        data: carePlanData,
        isPending
    } = useGetStatusCountByConsultant();

    const [chartData, setChartData] = useState<any>([
        { count: 0 },
        { count: 0 },
        { count: 0 },
        { count: 0 },
    ]);

    useEffect(() => {
        if (carePlanData && carePlanData?.length > 0) {
            
            const tempData = [
                { count: 0 },
                { count: 0 },
                { count: 0 },
                { count: 0 },
            ]

            const selectedMonth = carePlanDate ? carePlanDate.getMonth() + 1 : null;
            const selectedYear = carePlanDate ? carePlanDate.getFullYear() : null;

            if(selectedMonth && selectedYear) {
                const selectedData = carePlanData.find((item: any) => item.month === selectedMonth && item.year === selectedYear);
                if (selectedData) {
                    tempData[0].count = selectedData.statusList.find((item: any) => item.status === "Completed").count;
                    tempData[1].count = selectedData.statusList.find((item: any) => item.status === "InProgress").count;
                    tempData[2].count = selectedData.statusList.find((item: any) => item.status === "NotStarted").count;
                    tempData[3].count = selectedData.statusList.find((item: any) => item.status === "Emergency Stopped").count;
                }
            }

            setChartData(tempData);
        }
    }, [carePlanData, carePlanDate]);

    const data = {
        labels: ['Completed', 'Inprogress', 'NotStarted', "Stopped"],
        datasets: [
            {
                data: [chartData[0]?.count, chartData[1]?.count, chartData[2]?.count, chartData[3]?.count],
                backgroundColor: ['#6383F4', '#8569D5', '#EE7572', "#64ADF0"],
                borderWidth: 3,
                borderRadius: 100,
            },
        ],
    };

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
            mode: null,
        },
        cutout: '85%',
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: {
                top: 10,
                bottom: 10,
                left: 0,
                right: 20
            }
        }
    };

    return (
        <div className='col'>
            <BlockUI
                blocked={isPending}
                style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dotlottie-player
                        src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: "3rem", height: "3rem" }}
                        loop
                        autoplay
                    />
                </div>
                }
            >
                <Card className="h-16rem" style={{ borderRadius: "24px", position: "relative" }}>
                    <div className='flex flex-column'>
                        <div className='flex justify-content-between align-items-center'>
                            <p className='m-0 text-lg' style={{ color: '#727A99' }}>{t("carePlan")}</p>
                            <Calendar inputClassName='text-center' style={{ width: "7rem", height: "2rem" }} value={carePlanDate}
                                inputStyle={{ borderRadius: "8px" }}
                                onChange={(e) => {
                                    setCarePlanCardDate(e.value)
                                }} view="month" dateFormat="M yy"
                                minDate={sixMonthAgo}
                                maxDate={today}
                            />
                        </div>
                        <div className='flex justify-content-evenly align-items-center'>
                            <div style={{ position: 'relative', width: '12rem', height: '12rem' }}>
                                <Doughnut data={data} options={options} />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '55%',
                                        left: '45%',
                                        transform: 'translate(-50%, -50%)',
                                        textAlign: 'center',
                                        color: "#2D3967"
                                    }}
                                >
                                    <p className='m-0 text-sm' style={{ color: "#727A99" }}>{t("totalCare")}</p>
                                    <p className='m-0 text-sm' style={{ color: "#727A99" }}>{t("plans")}</p>
                                    <p className='m-0 text-4xl font-bold' style={{ color: "#2D3967" }}>
                                        {chartData[0]?.count + chartData[1]?.count + chartData[2]?.count + chartData[3]?.count}</p>
                                </div>
                            </div>

                            <div className="flex flex-column gap-3">
                                {[
                                    { label: t('completed'), count: chartData[0]?.count, color: "#6383F4" },
                                    { label: t('inprogress'), count: chartData[1]?.count, color: "#8569D5" },
                                    { label: t('notStarted'), count: chartData[2]?.count, color: "#EE7572" },
                                    { label: t('emergencyStopped'), count: chartData[3]?.count, color: "#64ADF0" }
                                ].map((item, index) => (
                                    <div key={index} className="flex justify-content-between align-items-center gap-6">
                                        <div className="flex justify-content-center align-items-center gap-2">
                                            <span style={{
                                                width: '0.5rem',
                                                height: '0.5rem',
                                                backgroundColor: item.color,
                                                borderRadius: '50%',
                                            }}></span>

                                            <p className="m-0 text-sm" style={{ color: "#727A99" }}>{item.label}</p>
                                        </div>
                                        <p className="m-0 text-sm font-bold" style={{ color: "#2D3967", textAlign: "left", minWidth: "20px" }}>{item.count}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Card>
            </BlockUI>
        </div>
    )
}

export default CarePlanCard;